export default __webpack_public_path__ + "static/media/logo.224e7ad5.png";